import { SectionHead } from "./SectionHead";

const BERGEN = [
  ["Industry", "Maritime · energy · finance · media · technology"],
  ["Capital", "Owners, investors and institutions with national reach"],
  ["Talent", "Research, universities, founders and technical communities"],
  ["Ambition", "One day can create attention. A recurring platform can change perception."],
];

export const Bergen = () => (
  <section className="ns-sec ns-bergen" id="bergen" data-testid="ns-bergen">
    <img className="ns-photo" src="/images/bergen-night.webp" alt="Bergen at night, seen from Fløyen" loading="lazy" />
    <div className="ns-shade" aria-hidden />
    <span className="ns-credit">Photo · Svein-Magne Tunli · CC BY-SA 4.0</span>
    <div className="ns-wrap">
      <SectionHead nr="06" label="Built in Bergen" right="Bergen, Norway" />
      <div className="ns-grid">
        <div className="g-1-7">
          <h2 className="ns-h2" data-rv data-testid="ns-bergen-h"><i>Built in Bergen.</i><i>Designed for Norway.</i></h2>
          <p className="ns-lede mt" data-rv style={{ "--d": ".1s" }} data-testid="ns-bergen-sub">A national AI platform, built from Bergen. Norway's most important business conversations do not all have to happen in Oslo.</p>
        </div>
        <div className="g-8-12">
          <ul className="ns-ledger two" data-rv style={{ "--d": ".15s" }} data-testid="ns-bergen-points">
            {BERGEN.map(([k, v]) => <li key={k}><span className="t">{k}</span><span className="d">{v}</span></li>)}
          </ul>
          <p className="ns-p mt" data-rv style={{ "--d": ".3s" }} data-testid="ns-bergen-foot">Not a conference hosted in Bergen — an annual arena that puts Bergen firmly on the map for AI, technology and business. <b>Bergen is the place. Norway is the market. The standard is international.</b></p>
        </div>
      </div>
    </div>
  </section>
);
